module.exports = __webpack_public_path__ + "img/新·闻·中·心.507bd997.png";